import { queryOptions } from '@tanstack/react-query';
import { apiClient } from './client';

export const bookingKeys = {
  all: ['booking'],
  projects: (debitorUuid) => [
    ...bookingKeys.all,
    'projects',
    debitorUuid ?? 'all',
  ],
  allItems: () => [...bookingKeys.all, 'items'],
  items: (projectUuid) => [...bookingKeys.allItems(), projectUuid],
};

/*
 * Booking projects ("scope") are visible without an assumed role;
 * everything below a project requires the Hostsharing-Assumed-Roles
 * header (see the assume barrier in the project area).
 */
export const bookingQueries = {
  projects: () =>
    queryOptions({
      queryKey: bookingKeys.projects(),
      queryFn: async () => {
        const { data } = await apiClient.get('/booking/projects');
        return data;
      },
    }),
  projectsByDebitor: (debitorUuid) =>
    queryOptions({
      queryKey: bookingKeys.projects(debitorUuid),
      queryFn: async () => {
        const { data } = await apiClient.get(
          `/booking/projects?debitorUuid=${debitorUuid}`
        );
        return data;
      },
      enabled: !!debitorUuid,
    }),
  /*
   * Requires an assumed project role; the Hostsharing-Assumed-Roles
   * header is attached by the interceptor in api/assumedRoles.js.
   */
  items: (projectUuid) =>
    queryOptions({
      queryKey: bookingKeys.items(projectUuid),
      queryFn: async () => {
        const { data } = await apiClient.get(
          `/booking/items?projectUuid=${projectUuid}`
        );
        return data;
      },
      enabled: !!projectUuid,
    }),
};
